import React from 'react';
import { useTranslation } from 'react-i18next';

import { localizeNumber } from 'modules/common/helpers';

import { LANGUAGES, LOCAL_STORAGE_VARS } from 'modules/common/constants/enums';

const price = 28.92;

export interface PaymentDetailsProps {
  voucherInfo?: CouponInfoDTO;
}

const PaymentDetails = ({ voucherInfo }: PaymentDetailsProps) => {
  const { t } = useTranslation(['payment', 'common']);

  const lng =
    localStorage.getItem(LOCAL_STORAGE_VARS.SITE_LANGUAGE) || LANGUAGES.DE;

  const percentOff = voucherInfo?.percentOff || 0;

  const finalPrice = price * ((100 - percentOff) / 100);
  const formattedFinalPrice = localizeNumber(finalPrice.toFixed(2), lng);

  const amountVAT = ((finalPrice * 0.19) / 1.19).toFixed(2);
  const formattedVAT = localizeNumber(amountVAT, lng);

  const monthlyPrice = finalPrice / 12;
  const formattedMonthlyPrice = localizeNumber(monthlyPrice.toFixed(2), lng);

  return (
    <div className="t-rounded t-bg-beta-100 t-p-2.5 t-mt-5">
      <div className="t-flex t-justify-between">
        <p className="typo-delta">{t(`auth:monthly_price_label`)}</p>
        <p className="typo-delta">
          {t(`auth:price`, {
            price: formattedMonthlyPrice,
          })}
        </p>
      </div>
      <div className="t-flex t-justify-between">
        <p className="typo-delta">{t(`auth:yearly_price_label`)}</p>
        <p className="typo-delta">
          {t(`auth:price`, {
            price: formattedFinalPrice,
          })}
        </p>
      </div>

      <div className="t-flex t-justify-between t-mt-2.5">
        <p className="typo-zeta">{t('auth:included_vat_label')}</p>
        <p className="typo-zeta">
          {t(`auth:price`, {
            price: formattedVAT,
          })}
        </p>
      </div>

      <hr className="t-text-beta-200 t-my-2.5" />

      <div className="t-flex t-justify-between">
        <p className="typo-delta">{t('auth:today_due_price_label')}</p>
        <p className="typo-delta">
          {t(`auth:price`, {
            price: formattedFinalPrice,
          })}
        </p>
      </div>
    </div>
  );
};

export default PaymentDetails;
